import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {Link, useParams} from "react-router-dom";
import { Button } from "react-bootstrap";
import { getAllAboutUsBottomView, getAllAboutUsHeaderView, getAllAboutUsMissionView, getAllAboutUsOverStoryView, getAllAboutUsParagraphView, getAllAboutUsStepCardView, getAllAboutUsStoryParagraphView, getAllTeamParagraphByPartner } from "../../api/axios";

function Aboutus() {
  const { partnerId } = useParams();
  const [headerView, setHeaderView] = useState(null);
  const [paragraphView, setParagraphView] = useState(null);
  const [storyParagraphView, setStoryParagraphView] = useState(null);
  const [ourStoryView, setOurStoryView] = useState(null);
  const [missionView, setMissionView] = useState(null);
  const [stepCardsView, setStepCardsView] = useState(null);
  const [meetTeamView, setMeetTeamView] = useState(null);
  const [bottomTitleView, setBottomTitleView] = useState(null);

  useEffect(() => {
    if (!Number(partnerId)) return;
    fetchHeaderViewData();
    fetchParagraphViewData();
    fetchStoryParagraphViewData();
    fetchOverStoryViewData();
    fetchTeamViewData()
    fetchStepCardViewData()
    fetchMissionViewData()
    fetchBottomViewData()
  }, [partnerId]);


  const fetchHeaderViewData = async () => {
    try {
      const response = await getAllAboutUsHeaderView(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setHeaderView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchParagraphViewData = async () => {
    try {
      const response = await getAllAboutUsParagraphView(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setParagraphView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchStoryParagraphViewData = async () => {
    try {
      console.log('response: ', partnerId);
      const response = await getAllAboutUsStoryParagraphView(partnerId);
      if (response.data.data.length > 0) {
        setStoryParagraphView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchOverStoryViewData = async () => {
    try {
      const response = await getAllAboutUsOverStoryView(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setOurStoryView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchTeamViewData = async () => {
    try {
      const response = await getAllTeamParagraphByPartner(partnerId);
      console.log('response:*-*-**-*-*-*-**-**-*-* ', response);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setMeetTeamView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchStepCardViewData = async () => {
    try {
      const response = await getAllAboutUsStepCardView(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setStepCardsView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMissionViewData = async () => {
    try {
      const response = await getAllAboutUsMissionView(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setMissionView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBottomViewData = async () => {
    try {
      const response = await getAllAboutUsBottomView(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setBottomTitleView(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ContentWrapper>
       {partnerId ? ( <>
      <Title>Select a section</Title>
      <SectionWrapper>
        <Link to={`/${partnerId}/aboutus/header/view/${Number(headerView) ? headerView : 'create' }`}>
          <Button className="mb-0">Header Section</Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/paragraph/view/${Number(paragraphView) ? paragraphView : 'create' }`}>
          <Button className="mb-0">Header Paragraph Section</Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/our_story_paragraph/view/${Number(storyParagraphView) ? storyParagraphView : 'create' }`}>
          <Button className="mb-0">Our Story Paragraph Section </Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/ourstory/view/${Number(ourStoryView) ? ourStoryView : 'create' }`}>
          <Button className="mb-0">"Our Story" Section</Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/mission/view/${Number(missionView) ? missionView : 'create' }`}>
          <Button className="mb-0">"Mission" Section</Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/stepcards/view/${Number(stepCardsView) ? stepCardsView : 'create' }`}>
          <Button className="mb-0">Step Cards Section</Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/meet_the_team/view/${Number(meetTeamView) ? meetTeamView : 'create' }`}>
          <Button className="mb-0">“Meet the Team” Section</Button>
        </Link>
        <Link to={`/${partnerId}/aboutus/bottom_title/view/${Number(bottomTitleView) ? bottomTitleView : 'create' }`}>
          <Button className="mb-0">Bottom Title Section</Button>
        </Link>
      </SectionWrapper>
       </>) : (
        <Title>Select a section</Title>
      )}
    </ContentWrapper>
  );
}

export default Aboutus;
const ContentWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const SectionWrapper = styled.div`
  /* justify-content: center;
  align-items: center;
  gap: 12px; */
  display: flex;
  gap: 2rem;
  justify-content: center;
     @media (max-width:1400px) {
    gap: 2rem !important;
   }
     @media (max-width:1200px) {
    gap: 1rem !important;
   }
      @media (max-width:1600px) {
   flex-wrap: wrap;
   }
     @media (max-width:369px) {
   flex-direction:column;
   gap: 0.5rem !important;
   }
  // padding-top: 5rem;
`;
